export type TimeInputFormat = {
  pattern: string; // date-fns parse pattern
  is24?: boolean; // for additional checks
  exact?: boolean; // can apply while type
  invalid?: boolean; // can type input, but can`t apply
  transform?: (value: string) => string; // transform to pass pattern check if needed
  isValid?: (value: string | null) => boolean; // additional check inputted string
};

export const TIME_INPUT_SEPARATORS = [':', ',', '.', ' ']; // first separator use for display correct format
export const TIME_INPUT_MAIN_SEPARATOR = TIME_INPUT_SEPARATORS[0];

export const DAY_START_HOURS = 8;
export const HALF_DAY_HOURS = 12;
